import { ApolloLink } from '@apollo/client';

import { getAuthTokenUnsafe } from '~/contexts/UserAuthProvider';

// Exports
/** Sets authorization header */
export const baseAuthMiddleware = () => {
  return new ApolloLink((operation, forward) => {
    const authToken = getAuthTokenUnsafe();
    if (authToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${authToken}`,
        },
      });
    }
    return forward(operation);
  });
};
